var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',_vm._b({staticClass:"px-0 cursor-pointer shape-mask button-icon",class:{ active: _vm.active }},'Btn',Object.assign({}, _vm.$attrs),false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }